export default [
  {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services/Index.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'APP_SERVICES',
      action: 'read',
    },
  },
  {
    path: '/services/customer-search',
    name: 'ServiceCustomerSearchAdd',
    component: () => import('@/views/Services/CustomerSearch.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/services',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          active: true,
        },
      ],
      resource: 'APP_SERVICE_ADD',
      action: 'read',
    },
  },
  {
    path: '/services/add/:id',
    name: 'ServiceAdd',
    component: () => import('@/views/Services/Add.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/services',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          to: '/services/customer-search',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'APP_SERVICE_ADD',
      action: 'read',
    },
  },
  {
    path: '/services/edit/:id',
    name: 'ServiceEdit',
    component: () => import('@/views/Services/Edit.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_SERVICE_EDIT',
      action: 'read',
    },
  },
  {
    path: '/services/view/:id',
    name: 'ServiceView',
    component: () => import('@/views/Services/View.vue'),
    meta: {
      pageTitle: 'Servis',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/services',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'APP_SERVICE_VIEW',
      action: 'read',
    },
  },
]
